/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Styles */
import styles from "./styles";

const RadioList = ({
  options,
  selected,
  onChange,
  getValue = (option) => (typeof option === "string" ? option : option.value),
  getLabel = (option) => (typeof option === "string" ? option : option.label)
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.modalContent}>
      {options.map((option) => {
        const value = getValue(option);
        const label = getLabel(option);

        return (
          <label key={value} className={`form-check ${value === selected ? "form-check-selected" : ""}`}>
            <input
              type="radio"
              name="generalRadioInput"
              className={`form-check-input ${classes.checkbox}`}
              checked={selected === value}
              onChange={() => onChange(value)}
            />
            <span className="form-check-label">{label}</span>
          </label>
        );
      })}
    </div>
  );
};

export default RadioList;